import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {filter} from "rxjs/operators";

@Component({
  selector:"app-http404",
  templateUrl:"./http404.component.html",
  styleUrls:["./http404.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class Http404Component implements OnInit {
  error: any = {};

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    let _errSample = {
      headers:{
        normalizedNames:{},
        lazyUpdate:null,
        headers:{}
      },
      status:0,
      statusText:"Unknown Error",
      url:null,
      ok:false,
      name:"HttpErrorResponse",
      message:"Http failure response for (unknown url): 0 Unknown Error",
      error:{isTrusted:true}
    };

    this.route.queryParams.pipe(filter(params => params.error))
        .subscribe(params => {
          this.error = JSON.parse(params.error);
          console.log("ERROR:", this.error); // popular
        });
  }
}
